import { ITableColumn } from 'CorePackage/TableModule/interfaces/ITableColumn';

export function defaultMapper<T>(col: ITableColumn<T>) {
  return `${String(col.id)},${col.sort}`;
}

export function sortMapper<T>(col: ITableColumn<T>): string | null {
  return col.sort ? `${String(col.id)},${col.sort}` : null;
}

export function getSortOrder<T>(columns: ITableColumn<T>[], fn = defaultMapper): string {
  return columns
    .filter(col => col.sort)
    .map(fn)
    .join(';');
}
